import { __decorate, __param } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { Promises } from 'monaco-editor/esm/vs/base/common/async.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { Disposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { ThemeIcon } from 'monaco-editor/esm/vs/base/common/themables.js';
import { IUserDataProfilesService } from 'monaco-editor/esm/vs/platform/userDataProfile/common/userDataProfile.js';
import { defaultUserDataProfileIcon } from './userDataProfile.js';
let UserDataProfileService = class UserDataProfileService extends Disposable {
    get currentProfile() { return this._currentProfile; }
    constructor(currentProfile, userDataProfilesService) {
        super();
        this._onDidChangeCurrentProfile = this._register(( new Emitter()));
        this.onDidChangeCurrentProfile = this._onDidChangeCurrentProfile.event;
        this._onDidUpdateCurrentProfile = this._register(( new Emitter()));
        this.onDidUpdateCurrentProfile = this._onDidUpdateCurrentProfile.event;
        this._currentProfile = currentProfile;
        this._register(userDataProfilesService.onDidChangeProfiles(e => {
            const updatedCurrentProfile = e.updated.find(p => this._currentProfile.id === p.id);
            if (updatedCurrentProfile) {
                this._currentProfile = updatedCurrentProfile;
                this._onDidUpdateCurrentProfile.fire();
            }
        }));
    }
    async updateCurrentProfile(userDataProfile, preserveData) {
        if (this._currentProfile.id === userDataProfile.id) {
            return;
        }
        const previous = this._currentProfile;
        this._currentProfile = userDataProfile;
        const joiners = [];
        this._onDidChangeCurrentProfile.fire({
            preserveData,
            previous,
            profile: userDataProfile,
            join(promise) {
                joiners.push(promise);
            }
        });
        await Promises.settled(joiners);
    }
    getShortName(profile) {
        if (!profile.isDefault && profile.shortName && ThemeIcon.fromId(profile.shortName)) {
            return profile.shortName;
        }
        return `$(${defaultUserDataProfileIcon.id})`;
    }
};
UserDataProfileService = ( __decorate([
    ( __param(1, IUserDataProfilesService))
], UserDataProfileService));
export { UserDataProfileService };
